<article class="card" [class.stoplist]="entry.stoplist" [attr.tabindex]="entry.stoplist ? null : 0"
  (click)="onClick()" (keydown.enter)="onClick()">
  <div class="card__text">
    <h3 class="card__title">{{ entry.item | fieldTranslate: 'title' }}</h3>
    <p class="card__description">{{ entry.item | fieldTranslate: 'description' }}</p>

    <div class="card__bottom">
      <div class="card__price" *ngIf="entry.item.price | priceSeparator as price">
        <span class="card__from" *ngIf="entry.item.variability">{{ 'from' | translate }}</span>
        <b>{{ price.whole }}{{ price.separator }}{{ price.fraction }}</b> {{ currency }}
        <span class="card__size" *ngIf="entry.item.size">{{ entry.item.size }} {{ unit }}</span>
      </div>
      <app-allergen-pill *ngIf="!entry.stoplist" class="card__allergens" [allergens]="entry.item.allergens"
        [plain]="true" [max]="4" [size]="16"></app-allergen-pill>
    </div>
  </div>

  <div class="card__photo">
    <app-lazy-image [kind]="entry.kind" [imageUrl]="entry.item.image"></app-lazy-image>
    <app-label-banners *ngIf="!entry.stoplist" class="card__labels" [labels]="labels"></app-label-banners>
    <span *ngIf="entry.stoplist" class="card__soldout">{{ 'soldout' | translate }}</span>
  </div>
</article>
